<script>
  import fetchWrapper from '@/lib/fetchWrapper.js';
  import { emitter } from '@/main.js';
  export default {
    name: 'ProductFamilyHelper',
    data() {
      return {
        title: '',
        alignment: '',
        hpHandle: ''
      };
    },
    mounted() {
      this.title = this.$el.parentElement.getAttribute('data-title');
      this.alignment = this.$el.parentElement.getAttribute('data-alignment');
      this.hpHandle = this.$el.parentElement.getAttribute('data-hp-handle');
      emitter.on('showHelpGuide', this.moveHelpGuide);
      // showHelpGuide can be emitted before this component mounts and mitt does not replay,
      // so attempt the move now too or the link stays hidden for the life of the page.
      this.moveHelpGuide();
    },
    beforeUnmount() {
      emitter.off('showHelpGuide', this.moveHelpGuide);
    },
    methods: {
      moveHelpGuide() {
        const helpGuideSize = document.getElementById('HelpGuideSize');
        const sizeGuide = document.getElementById('size-guide-toggle');
        if (!helpGuideSize || !sizeGuide) return;
        if (sizeGuide.previousElementSibling !== helpGuideSize) {
          sizeGuide.before(helpGuideSize);
        }
        helpGuideSize.style.display = 'block';
      },
      getHelpGuide() {
        const updateContent = response => {
          const origSection = new DOMParser().parseFromString(response.result, 'text/html');
          const mainContent = origSection.getElementById('MainContent');
          const updatedSection = document.getElementById('more-info-modal-content');
          if (mainContent && updatedSection) {
            updatedSection.innerHTML = mainContent.innerHTML;
            document.dispatchEvent(new CustomEvent('theme:accordion:bind', { bubbles: true, detail: { root: updatedSection } }));
            document.dispatchEvent(new CustomEvent('theme:rte:bind', { detail: { root: updatedSection } }));
          }
          if (window.MicroModal) {
            window.MicroModal.show('more-info-modal', {
              disableScroll: true,
              onShow: function() {
                document.documentElement.classList.remove('aos-initialized');
                document.dispatchEvent(new CustomEvent('chat:hide', { bubbles: true }));
              },
              onClose: function() {
                document.documentElement.classList.add('aos-initialized');
                document.dispatchEvent(new CustomEvent('chat:show', { bubbles: true }));
              }
            });
          }
        };
        fetchWrapper.getPageContent(this.hpHandle, updateContent);
      },
    },
  };
</script>

<template>
  <button type="button" :class="`help-guide-toggle gt-p__small text-${this.alignment}`" v-html="title" @click="getHelpGuide"></button>
</template>
